// extracted by mini-css-extract-plugin
export var container = "lcArticleCalloutBlock-module--container--5f15f";
export var icon = "lcArticleCalloutBlock-module--icon--64ad8";
export var info = "lcArticleCalloutBlock-module--info--07893";
export var label = "lcArticleCalloutBlock-module--label--4105e";
export var text = "lcArticleCalloutBlock-module--text--22220";
export var warning = "lcArticleCalloutBlock-module--warning--1c6b2";